// Auto-generated section component extracted from Landing.jsx
import React from "react";

export default function ConceptSection({ api }) {
  const { t } = api || {};
  return (
<section id="concept" className="space-y-4">
                <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
                  {t.concept.heading}
                </h2>
                <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6">
                  <p className="text-slate-200 text-sm sm:text-base max-w-4xl">
                    {t.concept.body}
                  </p>
                </div>
              </section>
  );
}
